import * as React from "react";


const fields = (machineModelId, t) => {
    return {
        config: {columns: 1},
        fields: [
            {
                name: "id",
                label: "id",
                mandatory: true,
                column: 1,
                type: "unvisible"
            },
            {
                name: "name",
                label: t ? t("common.name") : "Nazwa",
                mandatory: true,
                column: 1,
                type: "custom",


            },
            {
                name: "machineModelId",
                label: "machineModelId",
                mandatory: true,
                column: 1,
                type: "unvisible",
                defaultValue: machineModelId
            }
        ]


    }
};

export default fields;